import React from 'react';

import MuiContainer, {
  ContainerProps as MuiContainerProps,
} from '@mui/material/Container';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Container = withCoreProps<ContainerProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<ContainerProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiContainer {...props} className={clsxClass}>
        {children}
      </MuiContainer>
    );
  },
  ['maxWidth'],
);

export type ContainerProps = Partial<CoreProps> & MuiContainerProps;
